import { Pipe, PipeTransform } from '@angular/core';
import { Referrer } from '../../classes/referrer';

@Pipe({
    name: 'referrerGlobalSearchFilter',
    pure: false
})
export class ReferrerGlobalSearchFilterPipe implements PipeTransform {
    transform(referrerList: Array<Referrer>, filterValue: string): any {
        if (!referrerList || !filterValue) {
            return referrerList;
        }

        const normalizedFilter = filterValue.toLowerCase().trim();
        return referrerList.filter(referrer => {
            const id = String(referrer.IDReferrer ?? '').toLowerCase();
            const name = (referrer.Name || '').toLowerCase();
            const surname = (referrer.Surname || '').toLowerCase();
            const email = (referrer.Email || '').toLowerCase();

            return id.indexOf(normalizedFilter) !== -1
                || name.indexOf(normalizedFilter) !== -1
                || surname.indexOf(normalizedFilter) !== -1
                || email.indexOf(normalizedFilter) !== -1;
        });
    }
}
